<template>
  <div id="wrapper">
    <Nav :message="message" />
    <BonusForecast />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import BonusForecast from '@/components/profile/BonusForecast.vue'

export default {
  name: 'bonus',
  props: ['message'],
  components: {
    Nav,
    BonusForecast
  }
}
</script>